import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Ring, SeverityBadge } from "@/components/Primitives";
import { Sparkles } from "lucide-react";
import { toast } from "sonner";

export default function CustomerSuccess() {
  const [clients, setClients] = useState([]);
  const [qbr, setQbr] = useState(null);
  const [loading, setLoading] = useState(false);
  useEffect(() => { api.get("/dashboard/customer-success").then(r => setClients(r.data)); }, []);
  const generateQBR = async (cid) => {
    setLoading(true);
    try { const r = await api.post(`/ai/qbr/${cid}`); setQbr(r.data); toast.success("QBR generated"); } finally { setLoading(false); }
  };
  return (
    <div className="space-y-6">
      <div>
        <div className="text-[10px] uppercase tracking-[0.18em] text-zinc-500 font-mono">Customer Success</div>
        <h1 className="font-display text-3xl font-semibold tracking-tight mt-1">Account Health Overview</h1>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
        {clients.map(c => (
          <div key={c.id} className="bg-zinc-950 border border-zinc-900 rounded-md p-5" data-testid={`cs-card-${c.id}`}>
            <div className="flex items-start justify-between">
              <div>
                <div className="text-[10px] uppercase tracking-widest text-zinc-500 font-mono">{c.industry}</div>
                <h2 className="font-display text-xl tracking-tight">{c.name}</h2>
              </div>
              <SeverityBadge level={c.renewal_risk==='high'?'high':c.renewal_risk==='medium'?'medium':'low'}>{c.renewal_risk} risk</SeverityBadge>
            </div>
            <div className="flex items-center gap-4 mt-4">
              <Ring value={c.health_score} label="Health" size={70} />
              <div className="text-xs space-y-1 text-zinc-400">
                <div>Open tickets: <span className="font-mono text-zinc-200">{c.open_tickets}</span></div>
                <div>Open findings: <span className="font-mono text-zinc-200">{c.open_findings}</span></div>
                <div>Recurring: <span className="font-mono text-zinc-200">{c.recurring_issues}</span></div>
                <div>Assets: <span className="font-mono text-zinc-200">{c.asset_count}</span></div>
              </div>
            </div>
            <button onClick={()=>generateQBR(c.id)} data-testid={`cs-qbr-${c.id}`} className="mt-4 w-full inline-flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-700 text-white text-xs rounded px-3 py-2"><Sparkles size={12}/> Generate QBR</button>
          </div>
        ))}
      </div>
      {qbr && (
        <div className="bg-zinc-950 border border-zinc-900 rounded-md p-5">
          <div className="font-display font-medium mb-2">QBR for {qbr.client?.name}</div>
          <pre className="text-xs whitespace-pre-wrap text-zinc-300 leading-relaxed" data-testid="qbr-output">{qbr.qbr}</pre>
        </div>
      )}
    </div>
  );
}
